export const headersData = (translations:any) => {
    return {
        ONE: translations?.BANK?.PARTNER_NAME,
        TWO: translations?.BANK?.INSURER_NAME,
        THREE: translations?.BANK?.PARTNER_TYPE,
        FOUR: translations?.BANK?.BANK_NAME,
        FIVE: translations?.BANK?.BANK_ACC_NO,
        SIX: translations?.BANK?.BANK_ACC_NAME,
        SEVEN: translations?.BANK?.CREDIT_TERM,
        EIGHT: translations?.BANK?.CANCEL_TERM,
        NINE: translations?.BANK?.DISCOUNT_TO_OTO,
        TEN: translations?.BANK?.DISBURSEMENT_FEES,
        ELEVEN: translations?.commonMsg?.action,
        TWELVE: translations?.BANK?.STATUS,
    }
}
export type OptionType = {
  value: number;
  label: string;
};

export const KEYS:Record<string,any> ={
    ONE:"partner_id",
    TWO:"insurer_id",
    THREE:"payment_type",
    FOUR:"bank_id",
    FIVE:"bank_acc_no",
    SIX:"bank_acc_name",
    SEVEN:"credit_term",
    EIGHT:"cancel_term",
    NINE:"discount_to_oto",
    TEN:"disbursement_fees",
    TWELVE:"status"

}
export const REQUIRED_KEYS: (keyof BankFeesRow)[] = [
    KEYS.ONE,
    KEYS.TWO,
    KEYS.THREE,
    KEYS.FOUR,
    KEYS.FIVE,
    KEYS.SIX,
    KEYS.SEVEN,
    KEYS.EIGHT,
    KEYS.NINE,
    KEYS.TEN,
    KEYS.TWELVE
];

export const DROPDOWN_KEYS: String[] = [
    KEYS.ONE,
    KEYS.TWO,
    KEYS.FOUR,
    KEYS.THREE,
    KEYS.TWELVE,
];
export const CURRENCY_KEYS: String[] = [KEYS.TEN];
export const NUMBER_KEYS:String[] = [KEYS.SEVEN,KEYS.EIGHT,KEYS.TEN,KEYS.TWELVE];
export const DECIMAL_KEYS: String[] = [KEYS.NINE];

export type BankFeesRow = {
   [K in typeof KEYS[keyof typeof KEYS]]: string | number;
};

export const DEFAULT_BANK_STATUS = 1;

export const createEmptyBankFeesRow = (
  defaultStatus: string | number = DEFAULT_BANK_STATUS
): BankFeesRow => ({
    [KEYS.ONE]: "",
    [KEYS.TWO]: "",
    [KEYS.THREE]: "",
    [KEYS.FOUR]: "",
    [KEYS.FIVE]: "",
    [KEYS.SIX]: "",
    [KEYS.SEVEN]: "",
    [KEYS.EIGHT]: "",
    [KEYS.NINE]: "",
    [KEYS.TEN]: "",
    [KEYS.TWELVE]: defaultStatus,
  });

const createInitialRows = (count: number): BankFeesRow[] => {
  return Array.from({ length: count }, () => createEmptyBankFeesRow());
};

const initialRows = createInitialRows(2);

export const bankFeesInitialList = {
  data: initialRows,
  pagination: {
    total: "18",
    limit: 10,
    pages: 2,
    cur_page: 1,
    prev_page: false,
    next_page: true,
  },
};
export interface DELETE_ROW {
  row: BankFeesRow;
  show: boolean;
  index: number;
}
export enum DELETE_CONFIRMATION {
  NO = 0,
  YES = 1,
  SHOW = 2
}
